module.exports = __webpack_public_path__ + "img/pic-joinus.ac4224f3.png";